// 🌟 引入分离出来的消息数据池
import { newsPool, smsPool, emailPool } from './phoneContent';

export function getEnding(s) {
    // 🌟 极高优级的特殊结局 (数值极端化)
    if (s.san <= 0) return "🏥 精神病院：屏幕里的代码组成了克苏鲁的触手，你微笑着被绑上了束缚带。";
    if (s.money >= 1000000) return "🏝️ 财富自由：屎山哪有马尔代夫的沙滩好玩？你套现离场，身后洪水滔天。";
    if (s.tech === 100 && s.stability >= 80) return "🌌 硅基飞升：AI自我迭代完成闭环，你作为首个'投诚者'被圈养在了赛博伊甸园。";
    if (s.self > 90 && s.tech < 30) return "🎭 伪神降临：你靠着把外包包装成自研AI糊弄了全世界，成为互联网最大的忽悠大师。";

    // 🌟 核心主线结局
    if (s.self <= 0) return "💀 兔死狗烹：系统完美运行，不再需要“基建负责人”。你被自己部署的AI一键开除。";
    if (s.tech > 90 && s.industry < 20) return "🤖 赛博降临：碳基生物被彻底清退，无人的科技园里只有机箱风扇在日夜轰鸣。";
    if (s.tech > 80 && s.stability < 20) return "🔥 智械危机：AI生成的超维面条代码导致全球金融系统瘫痪，人类一夜回到蒸汽时代。";
    if (s.industry > 70 && s.tech < 50) return "🧑 卢德胜利：AI泡沫破裂，大家发现还是人矿便宜。人类艰难守住阵地，继续敲着CRUD。";
    if (s.tags.includes("capital") && s.self > 50) return "💰 资本赢家：PPT造车大成功！在泡沫破裂前你成功敲钟上市，留下一地鸡毛。";
    if (s.industry === 0) return "👻 科技鬼城：全行业只剩你一个活人，每天的工作是给满头大汗的服务器机房开空调。";
    if (s.stability < 10) return "💥 屎山雪崩：嵌套了十万层的循环导致物理机房起火，文明在蓝屏中倒退三十年。";

    // 🌟 新增舆论暗线结局
    if (s.publicOpinion <= 0) return "🍅 全网公敌：你成为了互联网历史上的头号公敌，走在路上都会被扔鸡蛋，最终只能隐姓埋名逃离文明世界。";
    if (s.publicOpinion >= 100 && s.self > 50) return "👑 赛博教父：你不仅掌控了AI，还掌控了民意。你辞职创业，信徒们把你捧上了神坛。";

    // 🌟 兜底平庸结局
    return "⚖️ 人机共存：你每天一半时间写代码，一半时间给AI写的代码修Bug，维持着脆弱的平衡。";
}

export const generatePhoneContent = (state) => {
    // 🌟 核心引擎：遍历池子，只要满足 condition 的就直接推入手机内容
    const todayTrends = newsPool.filter(item => item.condition(state)).map(item => item.content);
    const sms = smsPool.filter(item => item.condition(state)).map(item => item.content);
    const email = emailPool.filter(item => item.condition(state)).map(item => item.content);

    return { todayTrends, sms, email };
};